export default __webpack_public_path__ + "static/media/Kedoya-Contact-Us.96dfd55b.jpg";